import React from "react";
import { styled } from "@mui/material/styles";
import Button from "@mui/material/Button";
import { Box } from "@mui/material";

// Create a styled Button component that leverages theme and props
export const StyledBox = styled(Box)(({ theme, variant, color }) => ({
  borderRadius: "5px",
  padding: "10px 20px",
  fontFamily: "Rigid Square",
  fontWeight: "bold",
  fontSize: "18px",
  lineHeight: "24px",
  textTransform: "uppercase",
  ...(variant === "text-link" && {
    border: `1px solid ${
      color === "primary"
        ? theme.palette.primary.main
        : (color === "error" ? theme.palette.error.main : theme.palette.secondary.main)
    }`,
    color:
      color === "primary"
        ? theme.palette.primary.main
        : (color === "error" ? theme.palette.error[400] : theme.palette.secondary.main),
  }),
  ...(variant === "contained" && {
    backgroundColor:
      color === "primary"
        ? theme.palette.primary[800]
        : theme.palette.secondary.main,
    color: theme.palette.primary.contrastText,
  }),
  ...(variant === "outlined" && {
    border: `1px solid ${
      color === "primary"
        ? theme.palette.primary.main
        : (color === "error" ? theme.palette.error.main : theme.palette.secondary.main)
    }`,
    color:
      color === "primary"
        ? theme.palette.primary.main
        : (color === "error" ? theme.palette.error[600] : theme.palette.secondary.main),
  }
),
}));

export default StyledBox;
